var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.noItems
    ? _c("div", [
        _c("h2", { staticClass: "checkout-warning" }, [
          _vm._v("It looks like your cart is empty 😕")
        ]),
        _vm._v(" "),
        _c("h2", { staticClass: "checkout-warning" }, [
          _vm._v("Please add some items " + _vm._s(_vm.itemIcon))
        ]),
        _vm._v(" "),
        _c("h2", { staticClass: "has-text-centered" }, [
          _c(
            "a",
            {
              staticClass: "full-width tp-link",
              attrs: { "aria-label": "view menu" },
              on: { click: _vm._navigateToHome }
            },
            [_c("b", [_vm._v("View Menu")])]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12155c74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12155c74","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/EmptyCart.vue
// module id = null
// module chunks = 